/* global productIdCart */
$(window).on('load', function () {
  setTimeout(() => {
    // productIdCart is defined in Spark under a widget named "productIdCart"
    const productId = document.querySelectorAll(`[data-product-id="${productIdCart}"]`).length > 0;
    if (
      $('body').hasClass('checkoutPage') &&
      $('.checkout-header h1').text().toLowerCase() === 'checkout review' &&
      productId
    ) {
      // Function to show the popup
      function showPopup() {
        const popupHTML = `
          <div id="cart-pop" class="cart-pop">
            <div class="cart-pop__content">
              <div class="modalClose" style="width:100%; text-align: right;">
                <a title="Close" id="buttonCloseModal" class="modalCloseButton button" tabindex="0"></a>
              </div>
              <h2>Mega Pass</h2>
              <p>The Mega Pass can only be redeemed one time during the 2025 Fair and is only valid on an Armband Day (October 2-3, October 6-10, or October 12).</p>
              <div class="cart-pop__buttons">
                <button id="cart-pop-btn-yes" class="button">OK</button>
              </div>
            </div>
          </div>
              `;
        $('body').prepend(popupHTML);

        // Add click event listeners to the buttons
        $('#cart-pop-btn-yes').on('keypress click', function (event) {
          if (event.key == 'Enter' || event.type == 'click') {
            closePopup();
          }
        });

        $('#buttonCloseModal').on('keypress click', function (event) {
          if (event.key == 'Enter' || event.type == 'click') {
            closePopup();
          }
        });

        $(document).on('keydown', function (event) {
          if (event.key == 'Escape') {
            window.location.href = `${SITEBASEURL}checkout_info.aspx`;
          }
        });
      }

      // Function to close the popup
      function closePopup() {
        $('#cart-pop').fadeOut('fast', function () {
          $('#cart-pop').remove();
        });
      }
      function trapFocus() {
        const firstFocusable = $('#cart-pop-btn-yes');
        firstFocusable.focus();
        firstFocusable.on('keydown', (event) => {
          if (event.key === 'Tab') {
            if (event.shiftKey) {
              event.preventDefault();
              firstFocusable.focus();
            }
          }
        });
      }
      showPopup();
      trapFocus();
    }
  }, 3000);
});
